/**
 * 宿泊台帳管理の検索関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

// TODO Paginationを共通化
const CheckInSearchState = Record({
  search_keywords: '',
  search_room_ids: [],
  loading_room_option: true,
  search_room_options: [],
  search_check_in: null
})

export { CheckInSearchState }
